import * as React from 'react';
import { QuestionDto } from '../../../../pages/questionTypes';
import { translation } from '../../../../i18n';
import { RadioGroup } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { FormControlLabel } from '@material-ui/core';
import { Radio } from '@material-ui/core';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { AnswerDto, getEmptyAnswerDto } from '../../../../pages/answerTypes';
import { ChoiceDto } from '../../../../pages/choiceTypes';
import OnFinishedTextField from '../../../OnFinishedTextField';
import { Grid } from '@material-ui/core';

interface Props {
  question: QuestionDto,
  existingAnswer?: AnswerDto,
  saveAnswer: (answer: AnswerDto) => void
}


@observer
class MultipleChoiceQuestion extends React.Component<Props> {

  @observable private checkedValue: string = '';
  @observable private answer: AnswerDto = getEmptyAnswerDto();

  constructor(props: Props) {
    super(props);
    this.answer.question = this.props.question;

    const existingAnswer = this.props.existingAnswer;
    if (existingAnswer !== undefined || existingAnswer) {

      this.answer.answer = existingAnswer.answer;
      this.answer.choice = existingAnswer.choice;

      if (existingAnswer.choice) {
        this.checkedValue = existingAnswer.choice.id.toString()
      }
    }
  }

  public render() {
    return (
      <>
        {
          this.props.question.enableComment ?
            this.renderGridWithComment() :
            this.renderGridWithoutComment()
        }
      </>
    )
  }

  private renderGridWithoutComment() {
    return (
        <Grid item={true} sm={12} md={true}>
          { this.renderChoices() }
        </Grid>
    )
  }

  private renderGridWithComment() {
    return (
      <>
        <Grid item={true} sm={12} md={true}>
          { this.renderChoices() }
        </Grid>
        <Grid item={true} sm={12} md={true}>
          <OnFinishedTextField
            key={'multiple_choice_question_input_comment' + this.props.question.id}
            fullWidth={true}
            id='multiple_choice_question_input_comment'
            label={translation.t('answerComponent.comment')}
            onFinished={this.handleTextChange}
            value={this.getExistingComment()}
            multiline={true}/>
        </Grid>
      </>
    )
  }

  private renderChoices() {
    return (
      <>
        {
          this.props.question.choices &&
          <FormControl fullWidth={true}>
            <RadioGroup
              aria-label="choice"
              name="choice"
              row={true}
              value={this.checkedValue}
              onChange={this.handleChoiceChange}
              onClick={this.onChoiceClicked}
            >
              {
                this.props.question.choices.map(choice => (
                  <FormControlLabel
                    key={this.props.question.id.toString() + choice.id.toString()}
                    control={<Radio color={'primary'}/>}
                    value={choice.id.toString()}
                    label={choice.description}
                  />
                ))
              }
            </RadioGroup>
          </FormControl>
        }
      </>
    )
  }

  private getExistingComment(): string {
    if (this.props.existingAnswer === undefined) {
      return ''
    }
    return this.props.existingAnswer.answer
  }

  private handleChoiceChange = (event: any) => {
    this.checkedValue = event.target.value;
    this.answer.choice = this.getChoiceById(this.checkedValue);
    this.props.saveAnswer(this.answer)
  };

  private onChoiceClicked = (event: any) => {
    if (this.checkedValue === event.target.value) {
      this.checkedValue = '';
      this.answer.choice = undefined;
      this.props.saveAnswer(this.answer);
    }
  }

  private getChoiceById(choiceId: string): ChoiceDto | undefined {
    return this.props.question.choices!!.find((choice: ChoiceDto) => {
      return choice.id.toString() === choiceId
    })
  }

  private handleTextChange = (value: string) => {
    this.answer.answer = value;
    this.props.saveAnswer(this.answer);
  };

}

export default MultipleChoiceQuestion;

